import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { actionTypes, change } from 'redux-form';
import includes from 'lodash/includes';
import apex from '../apex';
import { isMakerOrTaker } from './orderHelper';
import { getOrderTypeByName } from './placeOrderHelper';
import { buyValue, orderTypes, sellValue } from '../constants/sendOrder/orderEntryFormConstants';
import { orderTotalSelector } from '../redux/selectors/orderTotalSelector';
import { selectedInstrumentSelector } from '../redux/selectors/instrumentPositionSelectors';
import { isMarginActiveSelector, marginAccountSelector } from '../redux/selectors/marginSelectors';

/**
 * Recalculate `order fee` and `total amount` for default order entry form
 */
export var recalculateOrderFormValues = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store, options) {
    var state, apexCore, level1, form, formName, initOrders, orders, selectedInstrument, totalAmount, isMarginActive, fee;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = store.getState();
            apexCore = state.apexCore;
            level1 = apexCore.level1;
            form = options.form, formName = options.formName, initOrders = options.orders;
            orders = [].concat(_toConsumableArray(initOrders));
            selectedInstrument = level1[selectedInstrumentSelector(state).InstrumentId] || {};
            form.side === buyValue ? orders.sort(function (a, b) {
              if (a.Price > b.Price) return 1;
              if (a.Price < b.Price) return -1;
              return 0;
            }) : orders.sort(function (a, b) {
              if (a.Price < b.Price) return 1;
              if (a.Price > b.Price) return -1;
              return 0;
            });
            totalAmount = orderTotalSelector(state, {
              form: form
            });
            if (totalAmount.toString() === 'NaN') totalAmount = 0;
            isMarginActive = isMarginActiveSelector(state);
            fee = void 0;
            if (!isMarginActive) {
              _context.next = 24;
              break;
            }
            _context.prev = 12;
            _context.next = 15;
            return getMarginOrderFeeForDefaultForm(store, form, totalAmount, selectedInstrument);
          case 15:
            fee = _context.sent;
            store.dispatch(change(formName, 'fee', fee));
            _context.next = 22;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](12);
            console.error('gerMarginOrderFee error: ', _context.t0);
          case 22:
            _context.next = 28;
            break;
          case 24:
            _context.next = 26;
            return getOrderFeeForDefaultForm(store, form, totalAmount, selectedInstrument);
          case 26:
            fee = _context.sent;
            store.dispatch(change(formName, 'fee', fee));
          case 28:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[12, 19]]);
  }));
  return function recalculateOrderFormValues(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var isOrderEntryFormChanged = function isOrderEntryFormChanged(_ref2) {
  var type = _ref2.type,
    meta = _ref2.meta;
  return type === actionTypes.CHANGE && !includes(['fee'], meta.field) && includes(['orderEntry', 'advancedOrderEntry', 'reportBlockTrade'], meta.form);
};
var getOrderFeeForDefaultForm = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(store, orderEntryForm, totalAmount, selectedInstrument) {
    var price, side, quantity, amount, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            price = getPriceForGetOrderFeeRequest(orderEntryForm, selectedInstrument);
            side = parseInt(orderEntryForm.side, 10);
            quantity = getQuantityForGetOrderFeeRequest(orderEntryForm, totalAmount);
            amount = getAmountForGetOrderFeeRequest(orderEntryForm);
            _context2.next = 6;
            return apex.connection.GetOrderFee(Object.assign({}, getBaseOptionsForGetOrderFeeRequest(store), {
              InstrumentId: selectedInstrument.InstrumentId,
              Amount: amount,
              Quantity: quantity,
              Side: side,
              Price: price,
              OrderType: parseInt(getOrderTypeByName(orderEntryForm.orderType), 10),
              MakerTaker: isMakerOrTaker(orderEntryForm.side, price, selectedInstrument.BestBid, selectedInstrument.BestOffer, orderEntryForm.orderType)
            }));
          case 6:
            response = _context2.sent;
            return _context2.abrupt('return', response);
          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));
  return function getOrderFeeForDefaultForm(_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var getMarginOrderFeeForDefaultForm = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(store, orderEntryForm, totalAmount, selectedInstrument) {
    var state, price, side, amount, marginAccount, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            state = store.getState();
            price = getPriceForGetOrderFeeRequest(orderEntryForm, selectedInstrument);
            side = parseInt(orderEntryForm.side, 10);
            amount = side === 1 ? totalAmount : orderEntryForm.quantity;
            marginAccount = marginAccountSelector(state);
            _context3.next = 7;
            return apex.connection.RPCPromise('GetMarginOrderFee', {
              OMSId: 1,
              AccountId: marginAccount.AccountId,
              InstrumentId: selectedInstrument.InstrumentId,
              Amount: amount,
              Quantity: orderEntryForm.quantity,
              Side: side,
              Price: price,
              OrderType: parseInt(getOrderTypeByName(orderEntryForm.orderType), 10),
              MakerTaker: isMakerOrTaker(orderEntryForm.side, price, selectedInstrument.BestBid, selectedInstrument.BestOffer, orderEntryForm.orderType)
            });
          case 7:
            response = _context3.sent;
            return _context3.abrupt('return', JSON.parse(response.o));
          case 9:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));
  return function getMarginOrderFeeForDefaultForm(_x7, _x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var getBaseOptionsForGetOrderFeeRequest = function getBaseOptionsForGetOrderFeeRequest(store) {
  var _store$getState = store.getState(),
    user = _store$getState.user;
  return {
    OMSId: user.userInfo.OMSId,
    AccountId: user.selectedAccountId
  };
};
var getPriceForGetOrderFeeRequest = function getPriceForGetOrderFeeRequest(formValues, selectedInstrument) {
  if (formValues.orderType === orderTypes.market.displayName) {
    if (formValues.side === buyValue) {
      return selectedInstrument.BestOffer;
    }
    return selectedInstrument.BestBid;
  }
  if (formValues.orderType === orderTypes.stopMarket.displayName) {
    return formValues.stopPrice;
  }
  if (formValues.orderType === orderTypes.reportBlockTrade.displayName) {
    var quantity = formValues.quantity,
      price = formValues.price;
    if (!quantity || !price) return undefined;
    if (formValues.side === buyValue) {
      if (formValues.quantity <= 0) {
        formValues.quantity = 1;
      }
      if (formValues.useNewForm) {
        // "useNewForm" indicates that we are treating the BlockTrade form
        // like a standard order entry, where user inputs the intended price.
        return formValues.price;
      }
      return formValues.price / formValues.quantity;
    } else {
      if (formValues.price <= 0) {
        formValues.price = 1;
      }
      if (formValues.useNewForm) {
        // "useNewForm" indicates that we are treating the BlockTrade form
        // like a standard order entry, where user inputs the intended price.
        return formValues.quantity;
      }
      return formValues.quantity / formValues.price;
    }
  }
  return formValues.limitPrice ? formValues.limitPrice : undefined;
};
var getQuantityForGetOrderFeeRequest = function getQuantityForGetOrderFeeRequest(formValues) {
  if (formValues.orderType === orderTypes.reportBlockTrade.displayName) {
    var price = formValues.price;
    if (!price) {
      formValues.quantity = 0;
      return undefined;
    }
    if (formValues.side === sellValue) {
      return formValues.price;
    }
  }
  return formValues.quantity;
};
var getAmountForGetOrderFeeRequest = function getAmountForGetOrderFeeRequest(formValues, totalAmount) {
  if (formValues.orderType === orderTypes.reportBlockTrade.displayName) {
    return 0;
  }
  return formValues.side === 1 ? totalAmount : formValues.quantity;
};